import { Box, Text } from '@chakra-ui/react';
import { EditorContent } from '@tiptap/react';
import Toolbar from './Toolbar';

const Editor = ({
  editor,
  height,
  enableToolbar,
  characterLimit,
  wrapperProps = {},
}) => {
  return (
    <Box padding="10px" {...wrapperProps}>
      <EditorContent
        editor={editor}
        style={{ height: height, overflowY: 'auto', transition: '1s height' }}
      />
      {enableToolbar && <Toolbar editor={editor} />}
      {characterLimit && (
        <Text fontSize="14px" fontWeight="medium" color="#8D8D8D !important">
          {editor?.storage?.characterCount?.characters()} / {characterLimit}
        </Text>
      )}
    </Box>
  );
};

export default Editor;
